import React, { Component } from 'react';
import { Create } from '$components/projects';
import { Spinner, Translate } from '$common';
import {
  getTaskForm,
  getTaskForms,
  updateTaskForm,
  createProject,
  updateProject,
  currentAccount,
  getRewards,
  updateReward,
  sendSlackMessage,
  getTaskFormTemplates,
  getTaskFormTemplate
} from '../../api';
import { browserHistory } from 'react-router';
import { showAlert, changeTitle } from '$actions/root';
import { connect } from 'react-redux';
import moment from 'moment';
import { omit, groupBy } from 'lodash';
import GetCountry from '$lib/get-country';
import { getDraft, deleteDraft } from '$lib/draft-manager';
import uploadFile from '$lib/upload-file';
import { errors } from "$lib/normalize";
import Cookies from 'js-cookie';

const defaults = {
  is_targeting_enabled: false,
  targetings: [
    {
      max_submission_count: 100,
      age_range: { young: false, adult: false, old: false },
      gender: { male: false, female: false }
    }
  ],
  scheduleProject: false,
  limitAvailability: false,
  max_submission_count_per_worker: 1,
  availability: {
    available_on_monday: true,
    available_on_tuesday: true,
    available_on_wednesday: true,
    available_on_thursday: true,
    available_on_friday: true,
    available_on_saturday: true,
    available_on_sunday: true,
    available_from: 0,
    available_to: 86400
  },
  scheduling: {
    starts_at: moment().toISOString(),
    finishes_at: moment().toISOString()
  }
};

const agent = (Cookies.get('agent') && JSON.parse(Cookies.get('agent'))) || {};

@connect(state => ({
  questions: state.form.taskForm ? state.form.taskForm.values.questions.filter( item => item._destroy !== true ) : [],
  setQuestions: questions => {
    state.form.taskForm = {
      values: {
        questions
      },
      initial: {
        questions
      }
    };
  }
}), { showAlert, changeTitle })
export default class CreateRoute extends Component {
  state = {
    templates: [],
    template: {},
    isTemplateFetching: false,
    errorMessages: {}
  };

  async loadData(props) {
    const { id: projectId } = (props || this.props).params;
    const { data: account } = await currentAccount();
    if (projectId) {
      this.getRewards(projectId);
    }
    this.setState({ account });
    defaults.account = account;
  }

  async loadTaskForm() {
    const { id: projectId } = this.props.params;

    if (projectId) {
      const { data: taskForms } = await getTaskForms(projectId);

      if (taskForms.length > 0) {
        const { data: taskForm } = await getTaskForm(projectId, taskForms[0].id);
        this.setState({ form: { id: taskForms[0].id, questions: taskForm.questions } });

        this.props.setQuestions(taskForm.questions);
      }
    }
  }

  async updateProject(values) {
    const { data: project } = await updateProject(values);
  }

  async getRewards(projectId) {
    const { data: rewards } = await getRewards(projectId);
    this.setState({ rewards });
  }

  async updateTaskForm(values) {
    await updateTaskForm(values);
  }

  async updateReward(projectId, values) {
    await updateReward(projectId, values);
  }

  async createReward(projectId, values) {
    await createReward(projectId, values);
  }

  async getTaskFormTemplates() {
    this.setState({ isTemplateFetching: true });
    const { data: templates } = await getTaskFormTemplates();
    this.setState({ templates, isTemplateFetching: false });
  }

  async getTaskFormTemplate(id) {
    const { data: template } = await getTaskFormTemplate(id);
    let variables = {};
    if (template.questions.length > 0) {
      template.questions.map( item => {
        const question_variables = item.label.match(/#(.*?)#/g);
        if (question_variables !== null) {
          question_variables.map( variable => {
            variables[String(variable).replace(/[#]/g, '') ] = '';
          })
        }
      });
    }
    this.props.setQuestions(template.questions);
    this.setState({ template: { ...template, variables } });
  }

  async create(project, task_form, template_id = null) {
    let groupedQuestions = groupBy(task_form.questions, 'jumpable_id');
    project.project_type = 'locationless';
    project.max_submission_count_per_worker = 1;

    project.rewards_attributes = [
      {
        title: moment().toISOString(),
        amount: parseFloat(project.reward),
        cost: parseFloat(project.reward) * 2,
        is_shown: true
      }
    ];

    task_form.questions.map( question => {
      question.question_options_attributes = question.question_options;
    });

    task_form = [{
      questions_attributes: task_form.questions,
      title: 'Task Form',
      complete_duration: 60,
      is_visible: true,
      is_scorable: false,
      tasks_attributes: [
        {
          title: project.name,
          short_description: project.short_description,
          description: project.short_description,
          max_submission_count: project.max_submission_count,
          status: 'available',
          max_submission_count_per_worker: 1,
          area_id: project.area_id
        }
      ]
    }];

    if (typeof template_id === "number" && typeof task_form.variables !== "undefined") {
      Object.keys(task_form.variables).map( variable => {
        task_form.questions_attributes.map( question => {
          question.label = question.label.replace(`#${variable}#`, task_form.variables[variable]);
        });
      });
    }

    for (var i in task_form.questions_attributes) {
      let item = task_form.questions_attributes[i];

      if (item.limit) {
        if (item.limit.min === "") {
          delete item.limit.min;
        }
        if (item.limit.max === "") {
          delete item.limit.max
        }
      }

      item.question_options_attributes.map( option => {
        option.jump_ids.map( (jump, jumpIndex) => {
          if (jump !== 0) {
            task_form.questions_attributes.map( (questionItem, questionIndex) => {
              if (questionItem.jumpable_id === groupedQuestions[jump][0].jumpable_id) {
                option.jump_ids[jumpIndex] = questionIndex+1;
              }
            })
          }
        })
      })

      if (typeof item.media !== "undefined") {
        if (typeof item.images_attributes === "undefined") {
          item.images_attributes = [];
        }

        if (typeof item.videos_attributes === "undefined") {
          item.videos_attributes = [];
        }

        if (typeof item.voice_records_attributes === "undefined") {
          item.voice_records_attributes = [];
        }

        for (var media_type in item.media) {
          if (item.media.hasOwnProperty(media_type)) {
            if (item.media[media_type].length > 0) {
              for (var index in item.media[media_type]) {
                const media = item.media[media_type][index];
                if (typeof media[0] !== "number") {
                  if (typeof media._destroy === "undefined") {
                    const url = await uploadFile('projects_assets', media);
                    if (media_type === 'images') {
                      item.images_attributes.push({ s3_key: url });
                    } else if (media_type === 'videos') {
                      item.videos_attributes.push({ s3_key: url });
                    } else if (media_type === 'voice_records') {
                      item.voice_records_attributes.push({ s3_key: url });
                    }
                  }
                } else {
                  const mediaData = { id: media[0], _destroy: typeof media._destroy !== "undefined" ? media._destroy : false };
                  if (media_type === 'images') {
                    item.images_attributes.push(mediaData);
                  } else if (media_type === 'videos') {
                    item.videos_attributes.push(mediaData);
                  } else if (media_type === 'voice_records') {
                    item.voice_records_attributes.push(mediaData);
                  }
                }
              }
            }
          }
        }
      }
    }

    try {
      const { data } = await createProject({ ...project, task_forms_attributes: task_form  });
      browserHistory.push('/');
      if (process.target[0] !== "staging") {
        sendSlackMessage(`${agent['firstName']} ${agent['lastName']}, ${this.state.account.name} tarafından *${project.price}* ${GetCountry.currencyCode} değerinde (*${project.reward}* ${GetCountry.currencyCode} / per squirrel) bir <https://ops.twentify.com/projects/${data.id}/overview|proje> oluşturuldu. :clap: :zap:`);
      }
      this.props.showAlert(Translate.get('success'), Translate.get('project_create_success_message'));
    } catch (e) {
      if (e.data) {
        const messages = errors(e.data.messages);
        this.setState({ errorMessages: messages });
      }
    }
  }

  update(project, task_form) {
    const { rewards, form } = this.state;

    this.updateProject(project);

    form.project_id = project.id;
    form.questions_attributes = task_form.questions;
    form.questions_attributes.map( item => {
      item.question_options_attributes = item.question_options;
      if (item.limit) {      
        if (item.limit.min === "") {
          delete item.limit.min;
        }
        if (item.limit.max === "") {
          delete item.limit.max
        }
      }
    });

    delete form.questions;

    this.updateTaskForm(form);

    if (rewards.length > 0) {
      this.updateReward(project.id, {
        id: rewards[0].id,
        title: moment().toISOString(),
        amount: parseFloat(project.reward),
        cost: parseFloat(project.reward) * 2,
        is_shown: true
      });
    } else {
      this.createReward(project.id, {
        title: moment().toISOString(),
        amount: parseFloat(project.reward),
        cost: parseFloat(project.reward) * 2,
        is_shown: true
      });
    }

    try{
      browserHistory.push('/');
      if (process.target[0] !== "staging") {
        sendSlackMessage(`*Havadis var!* <https://ops.twentify.com/projects/${task_form.project_id}/overview|Bir proje> güncellendi.`)
      }
      this.props.showAlert('Başarılı', 'Anket başarıyla güncellendi.');
    } catch(e) {
      console.log(e);
    }
  }

  componentWillMount() {
    this.props.changeTitle(Translate.get('start_project'))

    this.loadData();
    this.loadTaskForm();
    this.getTaskFormTemplates();

    setTimeout(() => {
      const { create_from_draft } = this.props.location.query;
      if (create_from_draft) {
        this.props.setQuestions(getDraft().questions);
      } else {
        deleteDraft();
      }
    }, 500);
  }

  render() {
    const { params, project, showAlert, questions } = this.props;
    const { templates, template, isTemplateFetching, form, account, errorMessages } = this.state;
    const { create_from_draft } = this.props.location.query;
    const draftData = getDraft();

    if (params.id) {
      if (typeof project !== "undefined") {
        project.account = this.state.account;

        return (
          <Create
            onSubmit={::this.update}
            projectDefaults={project}
            form={form}
            showAlert={showAlert}
            questions={questions}
            errors={errorMessages}
          />
        )

      } else {

        return (
          <Spinner block center />
        )

      }
    } else {
      if (create_from_draft) {
        draftData.project.account = account;
      }
      return (
        <Create
          onSubmit={::this.create}
          projectDefaults={create_from_draft ? draftData.project : defaults}
          showAlert={showAlert}
          templates={templates}
          template={template}
          getTaskFormTemplate={::this.getTaskFormTemplate}
          isTemplateFetching={isTemplateFetching}
          questions={questions}
          errors={errorMessages}
        />
      )

    }

  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/create.js